/**
 * @generated SignedSource<<00258632593a9cc70a1358462793f814>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreatePopupGroupSetInput = {
  clientMutationId?: string | null;
  siteId: string;
  name: string;
  memo?: string | null;
};
export type PopupGroupSetCreateFormContainer_Mutation$variables = {
  input: CreatePopupGroupSetInput;
  connections: ReadonlyArray<string>;
};
export type PopupGroupSetCreateFormContainer_MutationVariables = PopupGroupSetCreateFormContainer_Mutation$variables;
export type PopupGroupSetCreateFormContainer_Mutation$data = {
  readonly createPopupGroupSet: {
    readonly popupGroupSetEdge: {
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly memo: string | null;
      } | null;
    };
  } | null;
};
export type PopupGroupSetCreateFormContainer_MutationResponse = PopupGroupSetCreateFormContainer_Mutation$data;
export type PopupGroupSetCreateFormContainer_Mutation = {
  variables: PopupGroupSetCreateFormContainer_MutationVariables;
  response: PopupGroupSetCreateFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PopupGroupSetEdge",
  "kind": "LinkedField",
  "name": "popupGroupSetEdge",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PopupGroupSet",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "memo",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupGroupSetCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreatePopupGroupSetPayload",
        "kind": "LinkedField",
        "name": "createPopupGroupSet",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PopupGroupSetCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreatePopupGroupSetPayload",
        "kind": "LinkedField",
        "name": "createPopupGroupSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "popupGroupSetEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "143406f70b21ab14f4c98a2a7d37ac2b",
    "id": null,
    "metadata": {},
    "name": "PopupGroupSetCreateFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation PopupGroupSetCreateFormContainer_Mutation(\n  $input: CreatePopupGroupSetInput!\n) {\n  createPopupGroupSet(input: $input) {\n    popupGroupSetEdge {\n      node {\n        id\n        name\n        memo\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba5d9a885aec4bdbf4650bd252ffc693";

export default node;
